import { useBoolean } from '@hover/blueprint';
import { useEffect, useRef } from 'react';

export interface UseIdleTimeoutOptions {
  duration: number;
  pause?: boolean;
}

export const useIdleTimeout = ({
  duration,
  pause = false,
}: UseIdleTimeoutOptions) => {
  const [isIdle, { on: onIdle, off: onActive }] = useBoolean();
  const timeout = useRef<number>();

  useEffect(() => {
    const resetIdle = () => {
      onActive();

      window.clearTimeout(timeout.current);
      timeout.current = window.setTimeout(onIdle, duration * 1000);
    };

    if (pause) {
      window.clearTimeout(timeout.current);
      window.removeEventListener('mousemove', resetIdle);
      return undefined;
    }

    resetIdle();
    window.addEventListener('mousemove', resetIdle);

    return () => {
      window.removeEventListener('mousemove', resetIdle);
      window.clearTimeout(timeout.current);
    };
  }, [duration, onActive, onIdle, pause]);

  return isIdle;
};
